'use strict';
import $ from 'jquery';
import helper from './helper';
import templateHelper from './template-helper';
import webSocketHelper from './web-socket-helper';
import auctionHelper from './auction-helper';
import Cookies from 'js-cookie';

var auction = {
  _auctionBidForm: $('#auction-bid-form'),
  _auctionID: $('#auction-id').text(),
  _bidsTable: $('#bids-table'),
  _lastUpdated: 0,
  _timeouts: {
    updateBids: null,
  },
  _bidderIdToIndex: {},
  _highestBidderIndex: 0,
  _userId: 0,

  /**
   * Fetch latest bids
   */
  updateBids: function () {
    var self = this;

    // Synchronize clock with server while we're doing an ajax request already
    let ajaxRequestStart = Date.now();

    $.get(
      '/stage-ajax/getAuctionStatus',
      'stage-language=' + window.lang +
      '&auction=' + self._auctionID +
      '&lastUpdated=' + self._lastUpdated,
      function (data, status, xhr) {

        helper.syncTimeWithServer(xhr.getResponseHeader('Date'), Date.now() - ajaxRequestStart);

        if (typeof data.status === 'object') {
          self.updateBidView(data.status);
        }
      }
    );
  },

  /**
   * Fetch latest status
   * @param {string} auctionId - Auction id
   */
  checkFinalStatus: function(auctionId) {
    var self = this;
    $.get(
      '/stage-ajax/getAuctionStatus',
      'stage-language=' + window.lang +
      '&auction=' + auctionId,
      function (data) {
        if(typeof data.status === 'object') {

          var disableTimer = true;

          if(typeof data.status.endTime !== 'undefined') {
            var timeLeftSeconds = parseInt((data.status.endTime - Date.now()) / 1000);

            if(timeLeftSeconds > 0) {
              disableTimer = false;
            }
          }

          self.updateBidView(data.status, disableTimer);
        }
      }
    );
  },

  /**
   * Update bid view
   *
   * @param {object} data Auction status data
   * @param {boolean} disableTimer - Don't start timer
   */
  updateBidView: function (data, disableTimer) {
    var self = this;
    data = auctionHelper.formatAuctionData(data);

    this._lastUpdated = Date.now();
    this._auctionBidForm.find('input[name="lastUpdated"]').val(this._lastUpdated);

    if (typeof data !== 'undefined' && data !== null) {
      if (typeof data.endTime !== 'undefined') {
        this._endTime = data.endTime;

        if(!disableTimer) {
          helper.updateTimeLeft(this._auctionID, this._endTime, function() {
            self.checkFinalStatus(self._auctionID);
          });
        }
      }

      if (typeof data.priceNow !== 'undefined') {
        $('.auction-price-now').text(helper.formatPrice(data.priceNow));
        $('#loan_calculator input').val(data.priceNow);
      }

      if(typeof data.priceMonthly !== 'undefined' && data.priceMonthly) {
        $('.monthly-amount').text(helper.formatPrice(data.priceMonthly));
      }

      if (typeof data.minimum_bid !== 'undefined') {
        $('.auction-minimum-bid, #auction-bid-form .bid-amount').text(helper.formatPrice(data.minimum_bid));

        if (typeof data.minimum_bid === 'string') {
          data.minimum_bid = parseInt(data.minimum_bid.replace(/\D/g, ''));
        }

        const $auctionBid = $('#auction-bid, input[name="bid_assistant_limit"], #auction-bid-form input[name="amount"]');
        $auctionBid.attr('min', data.minimum_bid);
        $auctionBid.each(function(){
          let $this = $(this);
          if (!$this.val() || $this.val() < data.minimum_bid) {
            $this.val(data.minimum_bid);
          }
        });
      }

      if (typeof data.reservePriceReached !== 'undefined' && data.reservePriceReached === true) {
        $('.auction-reserve-reached').removeClass('d-none');
        $('.auction-reserve-not-reached').addClass('d-none');
      }

      if (typeof data.leader !== 'undefined') {
        $('.auction-leader').text(data.leaderName).toggleClass('auction-leader-is-self', data.latestBidIsOwn);
        $('.auction-leader').parent().toggleClass('d-none', !data.leader);

        this.userIsLeader = this._userId == data.leader; // eslint-disable-line eqeqeq

        /*
        2018-07-10: Now we want the leader to be able to top their own bid, no need for this code anymore.
        $('.user-not-winning').toggle(!this.userIsLeader);
        $('.user-winning').toggle(this.userIsLeader);
        */

        /*
        2018-07-10: Now we want the leader to be able to top their own bid, no need for this code anymore.
        if (this.userIsLeader) {
          // Use bid assistant only
          $('.bid-assistant-limit-container').css({ maxHeight: '1000px' });
          $('#bid-assistant').prop('checked', true);
        }
        else {
          $('.bid-assistant-limit-container').css({ maxHeight: '' });
          $('#bid-assistant').prop('checked', false);
        }
        */

        $('.bid-assistant-limit-container').css({ maxHeight: '' });
        $('#bid-assistant').prop('checked', false);
      }

      if (typeof data.bids !== 'undefined') {
        templateHelper.render('bidsTableBody', data, this._bidsTable.children('tbody'), 'prepend');
      }

      $('#load-auctions').toggle(typeof data.bids !== 'undefined' && data.bids.length > 5);
    }
  },

  /**
   * Get auctions list that was used in last search and generate prev/next links
   */
  generatePrevNext: function () {
    var auctionsList = Cookies.get('honk-car-auctions-list');
    if (typeof auctionsList === 'string') {

      try {
        auctionsList = JSON.parse(decodeURIComponent(auctionsList));

        if (typeof auctionsList.listUrl === 'string' && typeof auctionsList.list === 'object' && auctionsList.list.length > 1) {
          // Data found - generate html
          auctionsList.numAuctions = auctionsList.list.length;
          auctionsList.currentIndex = auctionsList.list.indexOf(window.location.pathname);

          if (auctionsList.currentIndex >= 1) {
            auctionsList.prevUrl = auctionsList.list[auctionsList.currentIndex - 1];
          }

          if (auctionsList.currentIndex < auctionsList.numAuctions - 1) {
            auctionsList.nextUrl = auctionsList.list[auctionsList.currentIndex + 1];
          }

          // Index starts from 0 for computers, but 1 for humans
          auctionsList.currentIndex++;

          templateHelper.render('auctionPrevNext', auctionsList, $('.auction-prev-next'));
        }
      } catch (e) {
        // Failed to parse auctions list - maybe there's no data available.
      }
    }
  },

  /**
   * Handle message that came through web socket
   *
   * @param {object} response The data that came from the web socket
   */
  _handleWebSocketMessage: function (response) {
    try {

      let data = response;
      if(typeof response === 'string') {
        data = JSON.parse(response.data);
      }

      if (typeof data === 'object' && typeof data.auction !== 'undefined' && data.auction == this._auctionID) { // eslint-disable-line eqeqeq
        this.updateBidView(data);
      }
    } catch (e) {
      // Error. ¯\_(ツ)_/¯
    }
  },

  _updateBidModal: function() {
    var $bidModal = $('#auction-bid-modal');
    var bidAmount = $('#auction-bid').val();

    // Update bid amount
    $bidModal.find('input[name="amount"]').val(bidAmount);
    $bidModal.find('input[name="bid_assistant_limit"]').val(bidAmount);
    $bidModal.find('.bid-amount').text(helper.formatPrice(bidAmount));

    // Remove possible previous form error messages
    $bidModal.find('.ajax-message').empty();
  },

  _updateLoginModal: function(e) {
    const $loginModal = $('#login-modal');
    const $bidBtn = $('#make-bid-box button');
    let text = '';

    //Show additional text if login modal was triggered by bid button
    if($(e.relatedTarget).is($bidBtn)) {
      text = '<p>' + window.translations.auctions_log_in_to_bid + '</p>';
    }

    $('.login-modal-preface', $loginModal).html(text);
  },

  init: function () {
    this._auctionBidForm = $('#auction-bid-form');

    /*
    2018-07-10: Now we want the leader to be able to top their own bid, no need for this code anymore.
    $('.user-not-winning').toggle(!this.userIsLeader);
    $('.user-winning').toggle(this.userIsLeader);
    */

    // Disable comma and dot from integer number inputs
    $('input[type="number"]:not([step])').on('keypress', function(event){
      if (event.which == 44 || event.which == 46) { // eslint-disable-line eqeqeq
        return false;
      }
    });

    if (!this._auctionID) {
      return; // Stop execution if there is no auction id (not on auction page?)
    }

    this.updateBids();
    this.generatePrevNext();

    var showBtn = $('#load-auctions');
    if (this._auctionBidForm.length === 0) {
      return; // Stop execution if there is no bid form (auction has probably ended)
    }

    webSocketHelper.subscribe(this._auctionID);
    webSocketHelper.addMessageHandler(this._handleWebSocketMessage.bind(this));

    //On click show all bids for now
    showBtn.on('click', function () {
      if ($('#table-wrap').hasClass('show')) {
        $('#table-wrap').removeClass('show');
        $('.gradient-layer').removeClass('transition-active');
        showBtn.text(window.translations.bids_show_all);
      } else {
        $('#table-wrap').addClass('show');
        $('.gradient-layer').addClass('transition-active');
        showBtn.text(window.translations.bids_show_less);
      }
    });

    $('#auction-bid-modal').on('show.bs.modal', this._updateBidModal.bind(this));
    $('#login-modal').on('show.bs.modal', this._updateLoginModal.bind(this));

    $('#make-bid-box button').on('click', function() {
      if (window.isLoggedIn) {
        $('#auction-bid-modal').modal('show');
      } else {
        $('#login-modal').modal('show', $(this));
      }
    });
  }
};

module.exports = auction;
